import * as React from "react";

export const InfoIcon = (props: any) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 .5c-1.177 0-2.27.297-3.281.89A6.397 6.397 0 0 0 1.39 3.72 6.364 6.364 0 0 0 .5 7c0 1.177.297 2.27.89 3.281A6.397 6.397 0 0 0 3.72 12.61c1.01.594 2.104.891 3.281.891s2.27-.297 3.281-.89a6.397 6.397 0 0 0 2.328-2.329c.594-1.01.891-2.104.891-3.281s-.297-2.27-.89-3.281A6.397 6.397 0 0 0 10.28 1.39 6.364 6.364 0 0 0 7 .5Zm0 1c1 0 1.927.25 2.781.75a5.57 5.57 0 0 1 1.969 1.969c.5.854.75 1.781.75 2.781 0 1-.25 1.927-.75 2.781a5.57 5.57 0 0 1-1.969 1.969A5.41 5.41 0 0 1 7 12.5c-1 0-1.927-.25-2.781-.75A5.57 5.57 0 0 1 2.25 9.781 5.41 5.41 0 0 1 1.5 7c0-1 .25-1.927.75-2.781A5.57 5.57 0 0 1 4.219 2.25 5.41 5.41 0 0 1 7 1.5ZM6.5 4v1h1V4h-1Zm0 2v4h1V6h-1Z"
      fill="#333"
    />
  </svg>
);
